<template>
    <div class="board" v-if="formData && errorData">
        <div class="bar">
            <b-icon icon="cart2" class="icon"></b-icon>
            <span>ออเดอร์สินค้าและบริการ</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <perfect-scrollbar class="mb-4 perfect-scrollbar-with-dropdown">
                <table>
                    <thead>
                        <tr>
                            <th class="text-center">#</th>
                            <th>สินค้า</th>
                            <th class="text-center">สัปดาห์ยาง</th>
                            <th class="text-center">ภาพถ่าย</th>
                            <th class="text-right">ราคา</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in formData.order.productList" :key="index">
                            <td class="column-number text-center">{{ (index + 1) }}</td>
                            <td>
                                <span class="text-nowrap" v-if="item.inventoryData.sku">SKU: {{ item.inventoryData.sku }}</span>
                                {{ item.productData.name }}
                                <div class="mt-2">
                                    <button class="btn btn-red btn-sm" @click="removeProduct(index)" v-if="jobState !== $Constants.JOB_STATUS_COMPLETE">ลบสินค้า</button>
                                </div>
                            </td>
                            <td class="column-input">
                                <template v-if="item.productData.productCategory === $Constants.CATEGORY_TIRE && selectedDot.length > 0">
                                    <dropdown
                                        v-model="selectedDot[index].value"
                                        placeholder="สัปดาห์ยาง"
                                        :options="optionDot[index]"
                                        :disabled="jobState === $Constants.JOB_STATUS_COMPLETE"
                                        :classes="{ input: [ 'input-field', errorData.order.productList.dot.find(x => x.blankIndex === index) ? 'invalid' : '' ] }"
                                        @change="changeSelectedDot($event, index)"
                                    ></dropdown>
                                    <input-dot
                                        v-model="item.input.dot"
                                        v-show="selectedDot[index].value === '-'"
                                        class="input-component"
                                        :inputClass="[ 'mt-1', 'input-field', errorData.order.productList.dot.find(x => x.blankIndex === index) ? 'invalid' : '' ]"
                                        :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                        placeholder="สัปดาห์ยาง">
                                    </input-dot>
                                    <div class="input-error-message" v-if="errorData.order.productList.dot.find(x => x.blankIndex === index)">โปรดเลือกสัปดาห์ยาง</div>
                                </template>
                                <div v-else class="text-center text-secondary">ไม่ต้องระบุ</div>
                            </td>
                            <td class="column-picture">
                                <template v-if="item.productData.productCategory === $Constants.CATEGORY_TIRE">
                                    <div class="input-picture">
                                        <template v-if="item.input.picture">
                                            <button @click="setPicture('', (index))" v-if="jobState !== $Constants.JOB_STATUS_COMPLETE">
                                                <b-icon icon="x"></b-icon>
                                            </button>
                                            <img :src="item.input.picture" />
                                        </template>
                                    </div>
                                    <take-picture
                                        v-if="jobState !== $Constants.JOB_STATUS_COMPLETE"
                                        fileErrorTitle="ประเภทไฟล์ไม่ถูกต้อง!"
                                        fileErrorMessage="โปรดเลือกไฟล์รูปภาพที่เป็น JPG หรือ PNG เท่านั้น"
                                        @load="setPicture($event, (index))"
                                    >ถ่ายรูป</take-picture>
                                    <div class="input-error-message" v-if="errorData.order.productList.picture.find(x => x.blankIndex === index)">โปรดเลือกสัปดาห์ยาง</div>
                                </template>
                                <div v-else class="text-center text-secondary">ไม่ต้องถ่ายรูป</div>
                            </td>
                            <td class="column-input">
                                <div class="input-price">
                                    <input type="text"
                                        v-model="item.input.price"
                                        class="input-field text-right"
                                        :class="{ 'invalid': errorData.order.productList.price.find(x => x.blankIndex === index) }"
                                        :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                        maxlength="6"
                                        @keypress="$AppUtility.inputOnlyNumber($event)" />
                                </div>
                                <div class="input-error-message" v-if="errorData.order.productList.price.find(x => x.blankIndex === index)">โปรดระบุราคาสินค้า</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <div class="no-data" v-if="formData.order.productList.length === 0">
                <b-icon icon="exclamation-diamond"></b-icon>
                <span>ไม่มีรายการสินค้า</span>
            </div>

            <div class="text-center">
                <button class="btn btn-dash btn-block btn-grey-outline" @click="openModalProduct()" v-if="jobState !== $Constants.JOB_STATUS_COMPLETE">เพิ่มสินค้า</button>
            </div>

            <perfect-scrollbar class="mt-4 mb-4 perfect-scrollbar-with-dropdown">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th class="text-center">#</th>
                            <th>รายการบริการเพิ่มเติมอื่นๆ</th>
                            <th class="text-right">ราคา</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in formData.order.serviceList" :key="index">
                            <td class="column-operation"><button class="btn btn-red btn-sm mt-2" @click="removeService(index)">ลบ</button></td>
                            <td class="column-number text-center">{{ (index + 1) }}</td>
                            <td>
                                <dropdown
                                    v-model="selectedServiceTopic[index].value"
                                    placeholder="-- หัวข้อบริการ --"
                                    :options="optionService"
                                    :disabled="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    :classes="{ input: ['input-field', (errorData.order.serviceList.topic.blank ? 'invalid' : '')] }"
                                    @change="changeServiceTopic($event, index)"
                                ></dropdown>
                                <input type="text"
                                    v-model="item.topic"
                                    v-show="selectedServiceTopic[index].value === '-'"
                                    class="input-field mt-2"
                                    :class="{ 'invalid': errorData.order.serviceList.topic.find(x => x.blankIndex === index) }"
                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    maxlength="100"
                                    placeholder="หัวข้อบริการเพิ่มเติม" />
                                <div class="input-error-message" v-if="errorData.order.serviceList.topic.find(x => x.blankIndex === index)">โปรดระบุหัวข้อบริการเพิ่มเติม</div>
                            </td>
                            <td class="text-right">
                                <div class="input-price">
                                    <input type="tel"
                                        v-model="item.price"
                                        class="input-field text-right"
                                        :class="{ 'invalid': errorData.order.serviceList.price.find(x => x.blankIndex === index) }"
                                        :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                        maxlength="6"
                                        @keypress="$AppUtility.inputOnlyNumber($event)"
                                        placeholder="ราคา" />
                                </div>
                                <div class="input-error-message" v-if="errorData.order.serviceList.price.find(x => x.blankIndex === index)">โปรดระบุค่าบริการ</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <div class="no-data" v-if="formData.order.serviceList.length === 0">
                <b-icon icon="exclamation-diamond"></b-icon>
                <span>ไม่มีรายการบริการอื่นๆ</span>
            </div>

            <div class="text-center">
                <button class="btn btn-dash btn-block btn-grey-outline" @click="addServiceList()" v-if="jobState !== $Constants.JOB_STATUS_COMPLETE">เพิ่มบริการหรือค่าใช้จ่ายอื่นๆ</button>
            </div>

            <perfect-scrollbar class="mt-4 mb-4">
                <table>
                    <thead>
                        <tr>
                            <th class="text-center">#</th>
                            <th>รายการส่วนลด</th>
                            <th class="text-right">ราคาส่วนลด</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in formData.order.discountList" :key="index">
                            <td class="column-number text-center">{{ (index + 1) }}</td>
                            <td>
                                <div class="discount-field">
                                    <button class="btn btn-red btn-sm" @click="removeDiscount(index)">ลบ</button>
                                    <input type="text"
                                        v-model="item.remark"
                                        class="input-field text-right"
                                        :class="{ 'invalid': errorData.order.discountList.remark.find(x => x.blankIndex === index) }"
                                        :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                        maxlength="100"
                                        placeholder="หัวข้อลดราคา" />
                                </div>
                                <div class="input-error-message" v-if="errorData.order.discountList.remark.find(x => x.blankIndex === index)">โปรดระบุหัวข้อลดราคา</div>
                            </td>
                            <td class="text-right">
                                <div class="input-price">
                                    <input type="tel"
                                        v-model="item.discount"
                                        class="input-field text-right"
                                        :class="{ 'invalid': errorData.order.discountList.discount.find(x => x.blankIndex === index) }"
                                        :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                        maxlength="6"
                                        @keypress="$AppUtility.inputOnlyNumber($event)"
                                        placeholder="ส่วนลด" />
                                </div>
                                <div class="input-error-message" v-if="errorData.order.discountList.discount.find(x => x.blankIndex === index)">โปรดระบุราคาส่วนลด</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <div class="no-data" v-if="formData.order.discountList.length === 0">
                <b-icon icon="exclamation-diamond"></b-icon>
                <span>ไม่มีส่วนลด</span>
            </div>

            <div class="text-center">
                <button class="btn btn-dash btn-block btn-grey-outline" @click="addDiscountList()" v-if="jobState !== $Constants.JOB_STATUS_COMPLETE">เพิ่มส่วนลด</button>
            </div>
        </div>

        <job-modal-product
            :isDisplay="isShowModalProduct"
            @hide="closeModalProduct()"
            @addProduct="addProduct($event)">
        </job-modal-product>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';
import MixinFormData from '@/components/job/FormData';
import JobModalProduct from '@/components/job/shared/ModalProduct';
import Helper from '@/resources/Helper';
import DBStock from '@/database/Stock';
import DBStoreService from '@/database/StoreService';

export default {
    mixins: [ MixinThemeBoard, MixinFormData ],
    components: {
        JobModalProduct
    },
    data() {
        return {
            isShowModalProduct: false,
            formData: null,
            selectedDot: [],
            selectedServiceTopic: [],
            optionDot: [],
            optionService: []
        }
    },
    props: {
        jobState: Number,
        loadData: Object,
        errorData: Object
    },
    mounted() {
        this.pageLoad();
    },
    methods: {
        async pageLoad() {
            await this.setupServiceOption();
            this.formData = this.initForm();

            if (this.loadData) {
                this.loadProductListTable();
                this.loadServiceListTable();
                this.loadDiscountListTable();
            }

            this.$emit('formData', this.formData);
        },
        bindBookingData(bookingData) {
            if (bookingData) {
                bookingData.reserve.product.forEach((item) => {
                    for (let index = 0; index < item.quantity; index++) {
                        this.formData.order.productList.push(this.mapTableData(item));
                    }
                });

                this.setupDotOption();
            }
        },
        initForm() {
            return {
                order: {
                    productList: [],
                    serviceList: [],
                    discountList: []
                }
            };
        },
        async loadProductListTable() {
            this.formData.order.productList = Helper.cloneObject(this.loadData.order.productList);
            await this.setupDotOption();

            this.formData.order.productList.forEach((item) => {
                const optionIndex = this.optionDot.findIndex(x => x.id === item.input.dot);

                this.selectedDot.push({ value: optionIndex > -1 ? item.input.dot : '-', isLoadData: true });
            });
        },
        loadServiceListTable() {
            this.formData.order.serviceList = Helper.cloneObject(this.loadData.order.serviceList);

            this.formData.order.serviceList.forEach((item) => {
                const optionIndex = this.optionService.findIndex(x => x.id === item.serviceTopic);

                this.selectedServiceTopic.push({ value: optionIndex > -1 ? item.serviceTopic : '-', isLoadData: true });
            });
        },
        loadDiscountListTable() {
            this.formData.order.discountList = Helper.cloneObject(this.loadData.order.discountList);
        },
        setPicture(value, index) {
            this.formData.order.productList[index].input.picture = value;
        },
        openModalProduct() {
            this.isShowModalProduct = true;
        },
        closeModalProduct() {
            this.isShowModalProduct = false;
        },
        addProduct(data) {
            for (let index = 0; index < data.quantity; index++) {
                this.selectedDot.push({
                    value: '',
                    isLoadData: false
                });
                
                this.formData.order.productList.push(this.mapTableData(data));
            }

            this.setupDotOption();
            this.closeModalProduct();
        },
        removeProduct(index) {
            this.optionDot.splice(index, 1);
            this.formData.order.productList.splice(index, 1);
        },
        addServiceList() {
            this.formData.order.serviceList.push({
                topic: '',
                price: ''
            });

            this.selectedServiceTopic.push({
                key: '',
                value: '',
                isLoadData: false
            });
        },
        removeService(index) {
            if (this.jobState !== this.$Constants.JOB_STATUS_COMPLETE) {
                this.formData.order.serviceList.splice(index, 1);
            }
        },
        addDiscountList() {
            this.formData.order.discountList.push({
                remark: '',
                discount: ''
            });
        },
        removeDiscount(index) {
            if (this.jobState !== this.$Constants.JOB_STATUS_COMPLETE) {
                this.formData.order.discountList.splice(index, 1);
            }
        },
        async setupServiceOption() {
            this.optionService = [];

            const result = await DBStoreService.get();

            if (result.content) {
                result.content.forEach((item) => {
                    this.optionService.push({
                        id: item.serviceTopic,
                        name: item.serviceTopic,
                        price: parseFloat(item.price)
                    });
                });
            }

            this.optionService.push({ id: '-', name: 'อื่นๆ' });
        },
        async setupDotOption() {
            for (const item of this.formData.order.productList) {
                const stock = await DBStock.getDetail(item.inventoryKey);

                this.optionDot.push(DBStock.generateDotOption(stock ? stock.dots : null, 'ระบุเอง'));
            }
        },
        changeSelectedDot(value, index) {
            if (!this.selectedDot[index].isLoadData) {
                this.formData.order.productList[index].input.dot = value === '-' ? '' : value;
            }

            this.selectedDot[index].isLoadData = false;
        },
        async changeServiceTopic(value, index) {
            if (!this.selectedServiceTopic[index].isLoadData) {
                if (value === '-') {
                    this.formData.order.serviceList[index].topic = '';
                } else {
                    const dataOption = this.optionService.find(x => x.id === value);

                    this.formData.order.serviceList[index].topic = value || '';
                    this.formData.order.serviceList[index].price = dataOption ? dataOption.price : '';
                }
            }

            this.selectedServiceTopic[index].isLoadData = false;
        },
        mapTableData(data) {
            return {
                inventoryKey: data.inventoryKey,
                inventoryData: data.inventoryData,
                productData: {
                    brand: data.productData.brand,
                    masterProductKey: data.productData.key,
                    name: data.productData.name,
                    productCategory: data.productData.productCategory,
                    size: data.productData.size
                },
                input: {
                    price: data.inventoryData.price,
                    dot: '',
                    picture: '',
                    quantity: 1
                }
            };
        }
    }
}
</script>

<style lang="scss" scoped>
table {
    td {
        vertical-align: top;

        &.column-operation {
            width: 80px;
        }

        &.column-number {
            width: 60px;
        }

        &.column-input {
            width: 180px;
        }

        &.column-picture {
            width: 280px;
        }

        .discount-field {
            position: relative;
            display: flex;
            align-items: center;

            .btn {
                position: absolute;
                left: 10px;
            }
        }

        .input-field {
            font-size: 14px;
        }
    }
}
</style>